// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-components-form-components-SwitchField-SwitchField-module__root","label":"app-portainer-components-form-components-SwitchField-SwitchField-module__label"};